module.exports = __webpack_public_path__ + "img/whatsapp.ec1cf776.svg";